import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { applicationSettings } from '../settings/application';
import { selectWriteDirection } from '../state/dexfSettings/dexfSettingsSelectors';
import { selectUserAgent } from '../state/userAgent/userAgentSelectors';

class BodyAttributes extends Component {
  static propTypes = {
    userAgent: PropTypes.object.isRequired,
    writeDirection: PropTypes.string.isRequired,
  };

  constructor(...args) {
    super(...args);

    const { userAgent, writeDirection } = this.props;
    const applicationName = applicationSettings.applicationName.toLowerCase();

    document.body.classList.add(userAgent.deviceType);
    document.body.classList.add(userAgent.orientation);
    document.body.classList.add(applicationSettings.uiPlatform);
    document.body.classList.add(applicationName);

    document.body.classList.add(writeDirection);
    document.body.setAttribute('dir', writeDirection);
  }

  componentDidUpdate(prevProps) {
    const userAgent = this.props.userAgent;
    const prevUserAgent = prevProps.userAgent;

    if (userAgent.deviceType !== prevUserAgent.deviceType) {
      document.body.classList.add(userAgent.deviceType);
      document.body.classList.remove(prevUserAgent.deviceType);
    }

    if (userAgent.orientation !== prevUserAgent.orientation) {
      document.body.classList.add(userAgent.orientation);
      document.body.classList.remove(prevUserAgent.orientation);
    }
  }

  render() {
    return null;
  }
}

export default connect(state => ({
  userAgent: selectUserAgent(state),
  writeDirection: selectWriteDirection(state),
}))(BodyAttributes);
